<template>
    <label>{{((page - 1) * size) + 1 + index}}</label>
</template>
<script>
export default {
    props: [
        'page', 'size', 'index'
    ],
}
</script>